export default __webpack_public_path__ + "static/media/IBMTagGroup.9dc16b84.svg";